import React from 'react';
import { useParams } from 'react-router-dom';
import styled from 'styled-components';
import CreatAgentModal from '../components/CreatAgentModal';

const StyledEditAgent = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 0px auto;
  padding: 20px;
  background-color: var(--white);
  border-radius: 20px;
  border: 1px solid rgba(157, 157, 157, 0.3);

  h1 {
    font-size: 24px;
    line-height: 28px;
    font-weight: 800;
    margin: 0 0 10px;

    @media screen and (min-width: 768px) {
      font-size: 30px;
      line-height: 38px;
    }
  }

  .desc {
    display: block;
    margin-bottom: 20px;
    font-size: 16px;
    line-height: 20px;
    font-weight: 400;
  }
`;

const EditAgent = () => {
  const { id } = useParams();

  return (
    <StyledEditAgent>
      <h1 className="title">Edit Agent</h1>
      <span className="desc">Edit your custom AI agent</span>
      <CreatAgentModal isEdit={{ id: id }} />
    </StyledEditAgent>
  );
};

export default EditAgent;
